export default __webpack_public_path__ + "static/media/rain.e5f2b543.svg";